import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const THUMB_SIZE = 14;

// Base style for the range input
export const audioScrubberBaseStyle = css`
  -webkit-appearance: none;
  appearance: none;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  height: 5px;
  margin: 0;
  outline: none;
  padding: 0;
  width: 100%;

  &:hover {
    &::-webkit-slider-thumb {
      opacity: 1;
    }
  }

  &::-webkit-slider-thumb {
    appearance: none;
    background: ${theme.colors.primary50};
    border-radius: 50%;
    cursor: pointer;
    height: ${THUMB_SIZE}px;
    opacity: 0;
    transition: opacity 200ms;
    width: ${THUMB_SIZE}px;
  }

  &::-moz-range-thumb {
    background: ${theme.colors.primary50};
    border-radius: 50%;
    cursor: pointer;
    height: ${THUMB_SIZE}px;
    width: ${THUMB_SIZE}px;
    border-color: ${theme.colors.primary50};
  }
`;

// Style for when progress button should always be visible
export const thumbVisibleStyle = css`
  &::-webkit-slider-thumb {
    opacity: 1;
  }
`;

// Style for filled track with gradient using CSS variable
export const filledTrackStyle = css`
  background: linear-gradient(
    to right,
    ${theme.colors.primary50} 0%,
    ${theme.colors.primary50} var(--audio-progress),
    ${theme.colors.neutral30} var(--audio-progress),
    ${theme.colors.neutral30} 100%
  );
`;

// Style for empty track with flat neutral background
export const emptyTrackStyle = css`
  background: ${theme.colors.neutral30};
`;

// Style for error state
export const errorStyle = css`
  cursor: default;

  &::-webkit-slider-thumb {
    display: none;
  }

  &::-moz-range-thumb {
    display: none;
  }
`;

// Style for compact mode
export const compactStyle = css`
  height: 3px;
`;
